
























































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class VideoListItem extends Vue {
  /**
   * A tag of root html element
   */
  @Prop({ default: "li", type: String })
  private tag!: string;

  /**
   * A text label to display
   */
  @Prop({ required: true, type: String })
  private label!: string;
}
